import React, { useState, useEffect } from 'react';
import PhoneForm from './components/PhoneForm';
import Dashboard from './components/Dashboard';
import LoginForm from './components/LoginForm';
import logo from './assets/Logo-Dre-Global.png'; // Ajusta la ruta según tu proyecto

const App = () => {
  const [currentPhone, setCurrentPhone] = useState(null);
  const [user, setUser] = useState(null);
  const [view, setView] = useState('dashboard');

  // Verificar sesión al cargar la app
  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await fetch('backend/auth.php', { credentials: 'include' });
        const result = await response.json();
        if (result.loggedIn) {
          setUser(result.user);
        } else {
          setUser(null);
        }
      } catch (error) {
        console.error('Error al verificar sesión:', error);
      }
    };
    checkSession();
  }, []);

  const handleSearch = async (imei) => {
    try {
      const response = await fetch(`backend/phones.php?imei=${imei}`, { credentials: 'include' });
      const result = await response.json();
      if (result.phone) {
        setCurrentPhone(result.phone);
        return result.phone; // Devuelve el teléfono actualizado
      } else {
        setCurrentPhone(null);
        alert(result.error || 'Teléfono no encontrado');
        return null;
      }
    } catch (error) {
      console.error('Error al buscar teléfono:', error);
    }
  };

  const handleAddPhone = async (phone) => {
    try {
      const response = await fetch('backend/phones.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(phone),
      });
      const result = await response.json();
      if (result.success) {
        alert('Teléfono registrado correctamente');
        setView('dashboard');
      } else {
        alert(result.error || 'Error al registrar teléfono');
      }
    } catch (error) {
      console.error('Error al registrar teléfono:', error);
    }
  };

  const handleAddMultiplePhones = async (phones) => {
    try {
      const response = await fetch('backend/phones.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(phones),
      });
      const result = await response.json();
      if (result.success) {
        alert('Teléfonos registrados correctamente');
        setView('dashboard');
      } else {
        alert(result.error || 'Error al registrar teléfonos');
      }
    } catch (error) {
      console.error('Error al registrar teléfonos:', error);
    }
  };

  const handleUpdateStatus = (updatedPhone) => {
    setCurrentPhone(updatedPhone);
  };

  const handleLogout = async () => {
    try {
      const response = await fetch('backend/auth.php', {
        method: 'DELETE',
        credentials: 'include',
      });
      const result = await response.json();
      if (result.success) {
        setUser(null);
        setCurrentPhone(null);
        alert('Sesión cerrada correctamente.');
        //window.location.reload(); // 🔥 Recarga la app y vuelve al LoginForm
      } else {
        alert(result.error || 'Error al cerrar sesión');
      }
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  if (!user) {
    return <LoginForm onLogin={setUser} />;
  }

  return (
    <div>
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8 flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <img src={logo} alt="DRE Logo" className="w-30 h-7" />
            <h1 className="text-2xl font-bold text-gray-900">TraceFlow</h1>
            {user && (
              <span className="text-sm text-gray-600 ml-4">Bienvenido, {user.name}</span>
            )}
          </div>

          <div className="flex space-x-4">
            <button
              onClick={() => setView('dashboard')}
              className={`px-3 py-2 rounded-md text-sm font-medium ${
                view === 'dashboard' ? 'bg-[#31a749] text-white' : 'text-gray-700 hover:bg-green-100'
              }`}
            >
              Dashboard
            </button>

            {(user.role === 'admin' || user.role === 'supervisor' || user.username === 'tech_receiving') && (
              <button
                onClick={() => setView('register')}
                className={`px-3 py-2 rounded-md text-sm font-medium ${
                  view === 'register' ? 'bg-[#31a749] text-white' : 'text-gray-700 hover:bg-green-100'
                }`}
              >
                Registrar Dispositivo(s)
              </button>
            )}

            <button
              onClick={handleLogout}
              className="px-3 py-2 rounded-md text-sm font-medium text-red-600 hover:bg-red-100"
            >
              Cerrar Sesión
            </button>
          </div>
        </div>
      </header>

      <main>
        {view === 'dashboard' ? (
          <Dashboard 
            user={user} 
            onSearch={handleSearch} 
            onUpdateStatus={handleUpdateStatus} 
            currentPhone={currentPhone}
          />
        ) : (
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <PhoneForm 
              onAddPhone={handleAddPhone} 
              onAddMultiplePhones={handleAddMultiplePhones} 
            />
          </div>
        )}
      </main>
    </div>
  );
};

export default App;
